export const setUsersElog = (usersElog) => {
    return {
        type: 'SET_USERS_ELOG',
        usersElog
    };
};